import type { Tag } from './types';

export const DEVICE_ID = 'default-device';
export const SYNC_INTERVAL_MS = 60_000;

export const TAGS: Array<{ value: Tag; label: string; color: string }> = [
  { value: 'default', label: '一般', color: '#8b9daf' },
  { value: 'work', label: '工作', color: '#5b8def' },
  { value: 'life', label: '生活', color: '#66bb6a' },
  { value: 'health', label: '健康', color: '#ef5350' },
];

export const PRIORITIES = [
  { value: 'low', label: '低', color: '#7e9aa6' },
  { value: 'medium', label: '中', color: '#5b8def' },
  { value: 'high', label: '高', color: '#e05a47' },
] as const;

export const CALENDAR_COLORS = [
  { value: 'blue', label: '藍', color: '#4f8fd8' },
  { value: 'teal', label: '青', color: '#2aa198' },
  { value: 'green', label: '綠', color: '#58a65c' },
  { value: 'amber', label: '黃', color: '#d89b25' },
  { value: 'pink', label: '粉', color: '#d96b8b' },
  { value: 'purple', label: '紫', color: '#8b6fc2' },
] as const;

export const WEEKDAYS = [
  { value: 1, label: '一' }, { value: 2, label: '二' }, { value: 3, label: '三' },
  { value: 4, label: '四' }, { value: 5, label: '五' }, { value: 6, label: '六' },
  { value: 7, label: '日' },
];
